import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum AnnouncementStatusEnum {
  Created = 'created',
  Working = 'working',
  Done = 'done',
  Error = 'error'
}

export class IAnnouncement {
  id: string;
  creatorId: number;
  companies: number[];
  regions: number[];
  createdAt: string;
  updatedAt: string;
  title: string;
  body: string;
  status: AnnouncementStatusEnum;
  count: number;
  type: string;
  errorMessage: string;
}

export class IAnnouncementResponse {
  @Type(() => IAnnouncement)
  result: IAnnouncement;
}

export class IAnnouncementListResponse extends IPagination {
  @Type(() => IAnnouncement)
  results: IAnnouncement[];
}

export class IAnnouncementQueryDto extends IQueryPaginationDto {
  id?: string;
}

export class IAnnouncementPostDto {
  companies: number[];
  regions: number[];
  title: string;
  body: string;
  type: string;
}
